import { render } from "./PromotionBanner.vue?vue&type=template&id=553e6c60"
import script from "./PromotionBanner.vue?vue&type=script&lang=js"
export * from "./PromotionBanner.vue?vue&type=script&lang=js"

import "./PromotionBanner.vue?vue&type=style&index=0&id=553e6c60&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__